// export const HIT_SERVER_URL =
//   process.env.REACT_APP_ENVIRONMENT === Environment.dev
//     ? "http://localhost:3002"
//     : "https://bot.addix.meme";

export const HIT_SERVER_URL = "https://bot.addix.meme";
